import { render, staticRenderFns } from "./DetailLayoutFullWidth.vue?vue&type=template&id=8ccce234"
import script from "./DetailLayoutFullWidth.vue?vue&type=script&lang=js"
export * from "./DetailLayoutFullWidth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports